var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-viewport-background-element",class:{ 'full-viewport-background-element--scrollable': _vm.scrollable }},[_c('div',{staticClass:"full-viewport-background-element__inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }